import React from 'react';

const BarChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path
        fill="#3B82F6"
        d="M16 22h-6a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V24a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#818CF8"
        d="M30 32h-6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V34a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#3B82F6"
        d="M44 14h-6a2 2 0 0 0-2 2v32a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#818CF8"
        d="M58 28h-6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V30a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
      <path
        fill="#3B82F6"
        d="M72 18h-6a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2"
        opacity="0.85"
      ></path>
    </svg>
  );
};

export default BarChartIcon;
